/* Nuskhera theme — scripts (no dependencies) */
(function () {
  'use strict';

  var GB = window.GB || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || GB.moneyFormat || '₹{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelims(n, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var match = fmt.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelims(cents, 2); break;
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      default: value = withDelims(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }
  GB.formatMoney = formatMoney;

  /* ---------- Drawers (menu, cart, filters) ---------- */
  var lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('gb-locked');
    var f = el.querySelector('[data-gb-autofocus]') || el.querySelector('button, a, input');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.gb-drawer.is-open, .gb-filters.is-open')) document.documentElement.classList.remove('gb-locked');
    var scrim = $('.gb-scrim.is-open');
    if (scrim && !$('.gb-filters.is-open')) scrim.classList.remove('is-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  GB.openDrawer = openDrawer;
  GB.closeDrawer = closeDrawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-gb-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-gb-open'));
      if (target) {
        e.preventDefault();
        openDrawer(target);
        if (target.classList.contains('gb-filters')) {
          var sc = $('.gb-scrim');
          if (sc) sc.classList.add('is-open');
        }
      }
      return;
    }
    var closer = e.target.closest('[data-gb-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.gb-drawer, .gb-filters') || $('.gb-filters.is-open'));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      $$('.gb-drawer.is-open, .gb-filters.is-open').forEach(closeDrawer);
    }
  });

  /* ---------- Cart (AJAX) ---------- */
  function cartSectionId() {
    var el = $('[data-gb-cart-drawer]');
    return el ? el.getAttribute('data-section-id') : null;
  }
  function updateCount(count) {
    $$('[data-gb-cart-count]').forEach(function (el) { el.textContent = count; });
  }
  function renderCart(sections) {
    var id = cartSectionId();
    if (!id || !sections || !sections[id]) return;
    var doc = new DOMParser().parseFromString(sections[id], 'text/html');
    var fresh = doc.querySelector('[data-gb-cart-inner]');
    var current = $('[data-gb-cart-inner]');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var count = doc.querySelector('[data-gb-cart-count-src]');
    if (count) updateCount(count.getAttribute('data-gb-cart-count-src'));
  }
  function fetchCartSection() {
    var id = cartSectionId();
    if (!id) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }
  GB.refreshCart = fetchCartSection;

  function cartError(form, message) {
    var box = form && form.querySelector('[data-gb-form-error]');
    if (box) { box.textContent = message; box.hidden = false; }
    else { window.alert(message); }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (GB.cartType === 'page' || !cartSectionId()) return;
    if (form.getAttribute('data-gb-ajax') === 'false') return;
    var submitter = e.submitter;
    if (submitter && submitter.name === 'checkout') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"][name="add"]') || submitter;
    var errBox = form.querySelector('[data-gb-form-error]');
    if (errBox) errBox.hidden = true;
    var label = btn ? btn.querySelector('[data-gb-btn-label]') || btn : null;
    var original = label ? label.textContent : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('is-loading'); }
    if (label) label.textContent = (GB.strings && GB.strings.adding) || 'Adding…';
    var fd = new FormData(form);
    fd.append('sections', cartSectionId());
    fd.append('sections_url', window.location.pathname);
    fetch((GB.routes && GB.routes.cartAdd ? GB.routes.cartAdd : '/cart/add') + '.js', {
      method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { cartError(form, data.description || data.message); return; }
        if (data.sections) renderCart(data.sections); else fetchCartSection();
        openDrawer($('#gb-cart-drawer'));
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('is-loading'); }
        if (label) label.textContent = original;
      });
  });

  function changeLine(line, qty) {
    var inner = $('[data-gb-cart-inner]');
    if (inner) inner.classList.add('is-loading');
    return fetch((GB.routes && GB.routes.cartChange ? GB.routes.cartChange : '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: qty, sections: [cartSectionId()], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { window.alert(data.description || data.message); }
        if (data.sections) renderCart(data.sections); else fetchCartSection();
      })
      .finally(function () { var i = $('[data-gb-cart-inner]'); if (i) i.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gb-line-change]');
    if (b && b.closest('[data-gb-cart-drawer]')) {
      e.preventDefault();
      changeLine(parseInt(b.getAttribute('data-line'), 10), parseInt(b.getAttribute('data-qty'), 10));
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-gb-line-input]');
    if (input && input.closest('[data-gb-cart-drawer]')) {
      var q = Math.max(0, parseInt(input.value, 10) || 0);
      changeLine(parseInt(input.getAttribute('data-line'), 10), q);
    }
  });

  /* ---------- Quantity steppers (product page / cart page) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gb-step]');
    if (!btn) return;
    var wrap = btn.closest('[data-gb-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    var min = parseInt(input.min || '1', 10);
    var v = (parseInt(input.value, 10) || min) + parseInt(btn.getAttribute('data-gb-step'), 10);
    input.value = Math.max(min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
    var autosubmit = wrap.closest('[data-gb-autosubmit]');
    if (autosubmit) {
      clearTimeout(autosubmit._t);
      autosubmit._t = setTimeout(function () { autosubmit.submit(); }, 450);
    }
  });

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-gb-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var form = root.querySelector('form[data-gb-product-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var picker = root.querySelector('[data-gb-variant-picker]');
    var slides = $$('[data-gb-slide]', root);
    var thumbs = $$('[data-gb-thumb]', root);
    var current = 0;

    function show(index) {
      if (!slides.length) return;
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
        if (i !== index) { var v = s.querySelector('video'); if (v) v.pause(); }
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      var t = thumbs[index];
      if (t && t.parentNode) {
        var p = t.parentNode;
        var left = t.offsetLeft - (p.clientWidth - t.clientWidth) / 2;
        p.scrollTo({ left: left, behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var prev = root.querySelector('[data-gb-prev]');
    var next = root.querySelector('[data-gb-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    var main = root.querySelector('.gb-gallery__main');
    if (main) {
      var sx = null;
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
        sx = null;
      });
    }
    var activeSlide = slides.findIndex ? slides.findIndex(function (s) { return s.classList.contains('is-active'); }) : 0;
    current = activeSlide > -1 ? activeSlide : 0;

    function selectedOptions() {
      if (!picker) return null;
      var values = [];
      $$('[data-gb-option]', picker).forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var select = group.querySelector('select');
        values.push(checked ? checked.value : select ? select.value : null);
      });
      return values;
    }
    function findVariant(values) {
      if (!product) return null;
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === values[i]; });
      }) || null;
    }
    function updateAvailability(values) {
      if (!product || !picker) return;
      $$('[data-gb-option]', picker).forEach(function (group, gi) {
        $$('input', group).forEach(function (input) {
          var test = values.slice();
          test[gi] = input.value;
          var match = product.variants.find(function (v) {
            return v.options.every(function (o, i) { return o === test[i]; });
          });
          input.classList.toggle('is-unavailable', !match || !match.available);
          if (group.hasAttribute('data-gb-packs')) {
            var card = input.nextElementSibling;
            if (!card) return;
            var now = card.querySelector('[data-gb-pack-now]');
            var was = card.querySelector('[data-gb-pack-was]');
            var save = card.querySelector('[data-gb-pack-save]');
            var sale = match && match.compare_at_price && match.compare_at_price > match.price;
            if (now) now.textContent = match ? formatMoney(match.price) : '';
            if (was) { was.hidden = !sale; was.textContent = sale ? formatMoney(match.compare_at_price) : ''; }
            if (save) {
              save.hidden = !sale;
              if (sale) {
                var pct = Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price);
                save.textContent = (group.getAttribute('data-save-template') || 'You save [pct]%').replace('[pct]', pct);
              }
            }
          }
        });
        var label = group.querySelector('[data-gb-option-value]');
        if (label) label.textContent = values[gi];
      });
    }
    function setPrice(v) {
      $$('[data-gb-price]', root).forEach(function (el) {
        var now = el.querySelector('[data-gb-price-now]');
        var was = el.querySelector('[data-gb-price-was]');
        var off = el.querySelector('[data-gb-price-off]');
        if (now) now.textContent = formatMoney(v.price);
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        if (was) { was.hidden = !sale; was.textContent = sale ? formatMoney(v.compare_at_price) : ''; }
        if (off) {
          off.hidden = !sale;
          if (sale) {
            var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
            off.textContent = (off.getAttribute('data-template') || '[pct]% OFF').replace('[pct]', pct);
          }
        }
      });
      $$('[data-gb-saved]', root).forEach(function (el) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        el.hidden = !sale;
        var amt = el.querySelector('[data-gb-saved-amount]');
        if (amt && sale) amt.textContent = formatMoney(v.compare_at_price - v.price);
      });
      $$('[data-gb-sticky-price]').forEach(function (el) { el.textContent = formatMoney(v.price); });
      $$('[data-gb-sticky-was]').forEach(function (el) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        el.hidden = !sale; el.textContent = sale ? formatMoney(v.compare_at_price) : '';
      });
    }
    function setButtons(v) {
      $$('[data-gb-atc]', root).concat($$('[data-gb-sticky-atc]')).forEach(function (btn) {
        var label = btn.querySelector('[data-gb-btn-label]') || btn;
        if (!v) {
          btn.setAttribute('disabled', 'disabled');
          label.textContent = GB.strings.unavailable;
        } else if (!v.available) {
          btn.setAttribute('disabled', 'disabled');
          label.textContent = GB.strings.soldOut;
        } else {
          btn.removeAttribute('disabled');
          label.textContent = btn.getAttribute('data-label') || GB.strings.addToCart;
        }
      });
    }
    function onVariantChange() {
      var values = selectedOptions();
      if (!values) return;
      updateAvailability(values);
      var v = findVariant(values);
      setButtons(v);
      if (!v) return;
      if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      $$('input[name="id"][data-gb-variant-mirror]').forEach(function (i) { i.value = v.id; });
      setPrice(v);
      if (v.featured_media) {
        var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') == v.featured_media.id; });
        if (idx > -1) show(idx);
      }
      $$('[data-gb-variant-title]', root).forEach(function (el) { el.textContent = v.title; });
      if (root.hasAttribute('data-gb-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    if (picker) {
      picker.addEventListener('change', onVariantChange);
      var initial = selectedOptions();
      if (initial) updateAvailability(initial);
    }

    /* Wishlist heart (saved in this browser) */
    var heart = root.querySelector('[data-gb-wish]');
    if (heart && product) {
      var key = 'gb-wish';
      var list = [];
      try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (err) { list = []; }
      heart.setAttribute('aria-pressed', list.indexOf(product.handle) > -1 ? 'true' : 'false');
      heart.addEventListener('click', function () {
        var on = heart.getAttribute('aria-pressed') !== 'true';
        heart.setAttribute('aria-pressed', on ? 'true' : 'false');
        list = list.filter(function (h) { return h !== product.handle; });
        if (on) list.push(product.handle);
        try { localStorage.setItem(key, JSON.stringify(list)); } catch (err) { /* storage unavailable */ }
      });
    }

    /* Sticky mobile bar */
    var sticky = document.querySelector('[data-gb-sticky]');
    var anchor = root.querySelector('[data-gb-buy-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var below = en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', !en.isIntersecting && below);
        });
      }).observe(anchor);
      var sbtn = sticky.querySelector('[data-gb-sticky-atc]');
      if (sbtn) {
        sbtn.addEventListener('click', function (e) {
          var mainBtn = root.querySelector('[data-gb-atc]');
          e.preventDefault();
          if (mainBtn && sbtn.getAttribute('data-mode') === 'add') {
            if (form.requestSubmit) form.requestSubmit(mainBtn); else mainBtn.click();
          } else {
            anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    }
  }

  /* ---------- Pincode delivery check ---------- */
  function parseList(s) {
    return String(s || '').split(/[\s,]+/).map(function (x) { return x.trim(); }).filter(Boolean);
  }
  var REGIONS = [[11, 11, 'Delhi'], [12, 13, 'Haryana'], [14, 16, 'Punjab & Chandigarh'], [17, 17, 'Himachal Pradesh'], [18, 19, 'Jammu, Kashmir & Ladakh'], [20, 28, 'Uttar Pradesh & Uttarakhand'], [30, 34, 'Rajasthan'], [36, 39, 'Gujarat'], [40, 44, 'Maharashtra & Goa'], [45, 49, 'Madhya Pradesh & Chhattisgarh'], [50, 53, 'Telangana & Andhra Pradesh'], [56, 59, 'Karnataka'], [60, 64, 'Tamil Nadu & Puducherry'], [67, 69, 'Kerala'], [70, 74, 'West Bengal & Sikkim'], [75, 77, 'Odisha'], [78, 78, 'Assam'], [79, 79, 'North East'], [80, 85, 'Bihar & Jharkhand']];
  var METRO_NAMES = { '110': 'Delhi', '400': 'Mumbai', '560': 'Bengaluru', '600': 'Chennai', '700': 'Kolkata', '500': 'Hyderabad', '411': 'Pune', '380': 'Ahmedabad', '201': 'Noida / Ghaziabad', '122': 'Gurugram', '121': 'Faridabad' };
  function zoneFor(pin) {
    var d = GB.delivery || {};
    if (!/^[1-9][0-9]{5}$/.test(pin)) return null;
    var p2 = parseInt(pin.slice(0, 2), 10);
    var region = null;
    REGIONS.forEach(function (r) { if (p2 >= r[0] && p2 <= r[1]) region = r[2]; });
    if (!region) return null;
    if (pin.slice(0, 3) === '744') region = 'Andaman & Nicobar';
    if (pin.slice(0, 4) === '6825') region = 'Lakshadweep';
    var metros = parseList(d.metroPrefixes);
    var remotes = parseList(d.remotePrefixes);
    var isMetro = metros.some(function (p) { return pin.indexOf(p) === 0; });
    var isRemote = remotes.some(function (p) { return pin.indexOf(p) === 0; });
    if (isMetro) return { region: METRO_NAMES[pin.slice(0, 3)] || region, range: d.metro || [3, 4], remote: false };
    if (isRemote) return { region: region, range: d.remote || [7, 10], remote: true };
    return { region: region, range: d.std || [4, 7], remote: false };
  }
  function dayLabel(n) {
    var dt = new Date();
    dt.setDate(dt.getDate() + n);
    try {
      return dt.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    } catch (e) { return dt.toDateString(); }
  }
  function initPin(box) {
    var input = box.querySelector('input');
    var btn = box.querySelector('[data-gb-pin-check]');
    var ok = box.querySelector('[data-gb-pin-ok]');
    var err = box.querySelector('[data-gb-pin-err]');
    var saved = '';
    try { saved = localStorage.getItem('gb-pin') || ''; } catch (e) { saved = ''; }
    if (saved && input) input.value = saved;
    function check() {
      var pin = String(input.value || '').replace(/\D/g, '').slice(0, 6);
      input.value = pin;
      var z = zoneFor(pin);
      if (!z) {
        ok.hidden = true;
        err.hidden = false;
        err.textContent = (GB.delivery && GB.delivery.error) || 'Please enter a valid 6-digit pincode.';
        return;
      }
      err.hidden = true;
      ok.hidden = false;
      ok.querySelector('[data-gb-pin-dates]').textContent = dayLabel(z.range[0]) + ' – ' + dayLabel(z.range[1]);
      ok.querySelector('[data-gb-pin-region]').textContent = z.region + ' · ' + pin;
      ok.querySelector('[data-gb-pin-note]').textContent = z.remote ? GB.delivery.remoteNote : GB.delivery.okNote;
      try { localStorage.setItem('gb-pin', pin); } catch (e) { /* ignore */ }
    }
    if (btn) btn.addEventListener('click', check);
    if (input) {
      input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 6); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });
    }
  }

  /* ---------- Delivery timeline dates ---------- */
  function initDates() {
    var d = GB.delivery || {};
    $$('[data-gb-date]').forEach(function (el) {
      var kind = el.getAttribute('data-gb-date');
      if (kind === 'today') el.textContent = el.getAttribute('data-today') || 'Today';
      if (kind === 'ship') el.textContent = dayLabel(d.shipMin || 1) + ' – ' + dayLabel(d.shipMax || 3);
      if (kind === 'deliver') {
        var r = d.std || [4, 7];
        el.textContent = dayLabel(Math.min(r[0], (d.metro || r)[0])) + ' – ' + dayLabel(r[1]);
      }
    });
  }

  /* ---------- Reels ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gb-reel-play]');
    if (!b) return;
    var reel = b.closest('.gb-reel');
    var video = reel && reel.querySelector('video');
    if (!video) return;
    $$('.gb-reel video').forEach(function (v) { if (v !== video) { v.pause(); v.closest('.gb-reel').classList.remove('is-playing'); } });
    if (video.paused) { video.play(); reel.classList.add('is-playing'); video.setAttribute('controls', ''); }
    else { video.pause(); reel.classList.remove('is-playing'); }
  });

  /* ---------- Collection filters, sort, load more ---------- */
  function initCollection(root) {
    var form = root.querySelector('[data-gb-filter-form]');
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"], select')) {
          var params = new URLSearchParams();
          new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') params.append(k, v); });
          window.location.search = params.toString();
        }
      });
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var params = new URLSearchParams();
        new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') params.append(k, v); });
        window.location.search = params.toString();
      });
    }
    var sort = root.querySelector('[data-gb-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
    var more = root.querySelector('[data-gb-load-more]');
    if (more) {
      more.addEventListener('click', function (e) {
        e.preventDefault();
        var url = more.getAttribute('href');
        if (!url) return;
        more.classList.add('is-loading');
        fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var grid = root.querySelector('[data-gb-grid]');
            var newGrid = doc.querySelector('[data-gb-grid]');
            if (grid && newGrid) Array.prototype.slice.call(newGrid.children).forEach(function (c) { grid.appendChild(c); });
            var newMore = doc.querySelector('[data-gb-load-more]');
            var seen = doc.querySelector('[data-gb-seen]');
            var curSeen = root.querySelector('[data-gb-seen]');
            if (seen && curSeen) curSeen.innerHTML = seen.innerHTML;
            var bar = doc.querySelector('[data-gb-seen-bar]');
            var curBar = root.querySelector('[data-gb-seen-bar]');
            if (bar && curBar) curBar.setAttribute('style', bar.getAttribute('style'));
            if (newMore) { more.setAttribute('href', newMore.getAttribute('href')); }
            else { more.remove(); }
          })
          .finally(function () { more.classList.remove('is-loading'); });
      });
    }
  }

  /* ---------- Track order ---------- */
  function initTrack(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var pattern = form.getAttribute('data-pattern') || '';
      var awbPattern = form.getAttribute('data-awb-pattern') || pattern;
      var modeInput = form.querySelector('input[name="track_mode"]:checked');
      var mode = modeInput ? modeInput.value : 'order';
      var raw = (form.querySelector('[name="track_id"]').value || '').trim();
      var id = raw.replace(/^#/, '');
      var contact = form.querySelector('[name="track_contact"]');
      var err = form.querySelector('[data-gb-track-err]');
      if (!id) { if (err) { err.hidden = false; } return; }
      if (err) err.hidden = true;
      var p = mode === 'awb' ? awbPattern : pattern;
      if (!p) {
        var fb = form.getAttribute('data-fallback');
        if (fb) window.location.href = fb;
        return;
      }
      var url = p.replace(/\{order\}/g, encodeURIComponent(id))
        .replace(/\{awb\}/g, encodeURIComponent(id))
        .replace(/\{contact\}/g, encodeURIComponent(contact ? contact.value.trim() : ''));
      if (form.getAttribute('data-new-tab') === 'true') window.open(url, '_blank', 'noopener');
      else window.location.href = url;
    });
    $$('input[name="track_mode"]', form).forEach(function (r) {
      r.addEventListener('change', function () {
        var label = form.querySelector('[data-gb-track-label]');
        var input = form.querySelector('[name="track_id"]');
        if (!label || !input) return;
        var awb = r.value === 'awb' && r.checked;
        label.firstChild.textContent = awb ? form.getAttribute('data-awb-label') : form.getAttribute('data-order-label');
        input.placeholder = awb ? form.getAttribute('data-awb-ph') : form.getAttribute('data-order-ph');
      });
    });
  }

  /* ---------- Request forms: return/replacement type toggles ---------- */
  function initRequestForm(form) {
    var radios = $$('input[name="contact[Request type]"]', form);
    function apply() {
      var checked = radios.filter(function (r) { return r.checked; })[0];
      var type = checked ? checked.getAttribute('data-kind') : '';
      $$('[data-gb-reasons]', form).forEach(function (sel) {
        var show = sel.getAttribute('data-gb-reasons') === type || !type;
        sel.closest('.gb-field').hidden = !show;
        sel.disabled = !show;
      });
    }
    radios.forEach(function (r) { r.addEventListener('change', apply); });
    apply();
  }


  /* ---------- Listicle: countdown + sticky bar ---------- */
  function initCountdown(el) {
    if (el._gbTimer) clearInterval(el._gbTimer);
    var raw = (el.getAttribute('data-gb-countdown') || '').trim();
    var daily = raw === 'daily';
    var end = NaN;
    function nextMidnightIST() {
      var ist = Date.now() + 330 * 60000;
      var dayStart = Math.floor(ist / 86400000) * 86400000;
      return dayStart + 86400000 - 330 * 60000;
    }
    if (daily) end = nextMidnightIST();
    else {
      raw = raw.replace(' ', 'T');
      if (raw.length === 16) raw += ':00';
      end = Date.parse(raw + '+05:30');
    }
    if (isNaN(end)) { el.hidden = true; return; }
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var out = el.querySelector('[data-gb-cd-out]');
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) {
        if (daily) { end = nextMidnightIST(); left = Math.floor((end - Date.now()) / 1000); }
        else { el.hidden = true; clearInterval(el._gbTimer); return; }
      }
      el.hidden = false;
      var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), sec = left % 60;
      if (out) out.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
    }
    tick();
    el._gbTimer = setInterval(tick, 1000);
  }
  var lstStickyBound = false;
  function initListicleSticky() {
    var bar = $('[data-gb-lst-sticky]');
    if (!bar || lstStickyBound) return;
    lstStickyBound = true;
    function update() {
      var b = $('[data-gb-lst-sticky]');
      if (!b) return;
      var offer = $('#offer');
      var offerOn = false;
      if (offer) { var r = offer.getBoundingClientRect(); offerOn = r.top < window.innerHeight && r.bottom > 0; }
      b.classList.toggle('is-visible', window.scrollY > 500 && !offerOn);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Init ---------- */
  function init() {
    $$('[data-gb-product]').forEach(initProduct);
    $$('[data-gb-pin]').forEach(initPin);
    $$('[data-gb-collection]').forEach(initCollection);
    $$('form[data-gb-track]').forEach(initTrack);
    $$('form[data-gb-request]').forEach(initRequestForm);
    $$('[data-gb-countdown]').forEach(initCountdown);
    initListicleSticky();
    initDates();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-gb-product]', e.target).forEach(initProduct);
    $$('[data-gb-pin]', e.target).forEach(initPin);
    $$('[data-gb-collection]', e.target).forEach(initCollection);
    $$('form[data-gb-track]', e.target).forEach(initTrack);
    $$('form[data-gb-request]', e.target).forEach(initRequestForm);
    $$('[data-gb-countdown]', e.target).forEach(initCountdown);
    initListicleSticky();
    initDates();
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-gb-cart-drawer]')) openDrawer($('#gb-cart-drawer'));
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-gb-cart-drawer]')) closeDrawer($('#gb-cart-drawer'));
  });
})();
